export default __webpack_public_path__ + "static/media/project2.ebb107e6.png";